












import { Vue, Component } from 'vue-property-decorator';
import { focusTabName, orderListTypes } from '@/const/order.ts';
import SearchForm from '@/components/shipping/order/SearchForm.vue';

@Component({
  components: {
    SearchForm,
  },
})
export default class OrderPrevious extends Vue {
  private readonly orderListTypes = orderListTypes.PREVIOUS;
  private readonly orderSearchTypes = focusTabName.ORDER_TAB;
}
